import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Topic from './watchAppHelpTopic.jsx';
import { ScreenChromeContext } from '../help/ScreenChrome.jsx';
import { HELP_PATH } from '../navigation/paths.js';

// Web stand-in for app/src/screens/WatchAppHelp/Steps.js: a topic told over
// several steps, one at a time, with Back / Next and the same "Step n / m" count
// the app carries. Same props as the app's Steps — title, steps, navigation — but
// the app's `navigation` (a React Navigation prop, used only to leave the topic)
// is ignored: leaving is a router navigation to wherever the web wrapper said the
// topic's back link goes (ScreenChromeContext), which is the topic list.
//
// As in the app the steps live in the topic, not in the router: Back from the
// first step and Finish from the last both leave for the list, and the browser's
// own Back returns to the list too rather than walking the steps.
export default function Steps({ title, steps }) {
  const navigate = useNavigate();
  const { backTo } = useContext(ScreenChromeContext);
  const [stepIndex, setStepIndex] = useState(0);

  const step = steps[stepIndex];
  const isFirst = stepIndex === 0;
  const isLast = stepIndex === steps.length - 1;
  const leave = () => navigate(backTo ?? HELP_PATH);

  return (
    <Topic
      title={title}
      body={step.body}
      diagram={step.diagram}
      footer={
        <div className="watch-steps">
          <button
            type="button"
            className="watch-steps__button"
            onClick={isFirst ? leave : () => setStepIndex(stepIndex - 1)}
          >
            Back
          </button>
          {/* Announced as it changes, since the copy and picture above it change
              without the page moving. */}
          <p className="watch-steps__count" aria-live="polite">
            Step {stepIndex + 1} / {steps.length}
          </p>
          <button
            type="button"
            className="watch-steps__button"
            onClick={isLast ? leave : () => setStepIndex(stepIndex + 1)}
          >
            {isLast ? 'Finish' : 'Next'}
          </button>
        </div>
      }
    />
  );
}
